/**
 * Vuetify colors scheme to be used in the layout
 */
const vuetifyColors = {
  /** @todo Change the primary color when the layout is finalised */
  primary: "#41CE65",
  white: "#FFFFFF",
  background: "#FBFBFB",
  blue: "#006BAF",
  error: "#B00020",
};

/**
 * Vuetify global theme configuration for the inboxaware application
 */
const vuetifyConfig = {
  theme: {
    dark: false,
    light: true,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: vuetifyColors.primary,
        white: vuetifyColors.white,
        background: vuetifyColors.background,
        blue: vuetifyColors.blue,
        error: vuetifyColors.error,
      },
    },
  },
};

export default Object.freeze(vuetifyConfig);
